import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useUser from "../../../hooks/useUser"
import { Avatar, List, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import FolderIcon from '@mui/icons-material/Folder'
import { Imagen } from "../imagenes";

export const ListProductos = ({busqueda, listado}) => {
  const { jwt, notification, logout} = useUser();

  const [categorias, setCategorias] = useState(listado);
  const [borrado, setBorrado] = useState("false");

  const getCategoriasFiltered = () => {
    setCategorias(()=>{
        if(busqueda !== "") {
            return listado.filter(
                categoria => {
                    return (
                      categoria.nombre.toLowerCase().includes(busqueda.toLowerCase()) 
                    );
                }
            )
        }else{
            return listado;
        }
    });
  };

    useEffect(() => {
      getCategoriasFiltered();
    }, [borrado, busqueda, listado]);

  const [open, setOpen] = useState("true");
  
  return (
    <div className="container listadoCategorias">

      {categorias &&
        categorias.map((categoria, index) => {
          
          return (
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} key={categoria.id}>
              <Link to={"/productos/" + categoria.id} >
              <ListItem  >
                <ListItemAvatar>
                  <Imagen imagenes={categoria.imagen} numImagenes="1" accion="listadoProducto" />                
                </ListItemAvatar>
                <ListItemText  primary={categoria.nombre} />
              </ListItem>
              </Link>
            </List>
          );
        })}
    </div>
  );
};

